import React from 'react'

import { range } from 'ramda'
import { compose, defaultProps, withHandlers } from 'recompose'
import styled from 'styled-components'

import {
  PORTFOLIO_CURRENT_RISK_VIEW_INDICATOR,
  PORTFOLIO_RISK_INDICATOR_CONTAINER,
} from 'utils/testing/testIDs'

import theme from '../../theme'

type Props = {
  count: number
  className?: string
  selected: number
  highlightColor?: string
  onItemClick: (index: number) => void
}

type ItemProps = {
  num: number
  highlight: boolean
  highlightColor?: string
  onClick: (index: number) => void
}

type ItemHandlers = {
  handleClick?: () => void
}

type MergedItemProps = ItemProps & ItemHandlers

const Container = styled.div`
  display: flex;
  margin-top: 20px;
  margin-left: -10px;
  justify-content: center;
`
const Dot = styled('div')<Pick<ItemProps, 'highlight' | 'highlightColor'>>`
  background-color: #cccfcf;
  border-radius: 99px;
  cursor: pointer;
  height: 8px;
  margin: 0 4px;
  width: 8px;

  ${(props) =>
    props.highlight &&
    `
    background-color: ${props.highlightColor};
  `};
`

const enhance = compose<MergedItemProps, MergedItemProps>(
  defaultProps<Partial<MergedItemProps>>({
    highlightColor: theme.colors.slate,
  }),
  withHandlers<MergedItemProps, ItemHandlers>({
    handleClick:
      ({ num, onClick }) =>
      () => {
        onClick(num)
      },
  }),
)

const Item = enhance((props) => (
  <Dot
    key={props.num}
    highlight={props.highlight}
    highlightColor={props.highlightColor}
    onClick={props.handleClick}
    data-testid={props.highlight ? PORTFOLIO_CURRENT_RISK_VIEW_INDICATOR : ''}
  />
))

export default (props: Props) => (
  <Container
    className={props.className}
    data-testid={PORTFOLIO_RISK_INDICATOR_CONTAINER}
  >
    {range(0, props.count).map((num) => (
      <Item
        key={num}
        num={num}
        highlight={props.selected === num}
        highlightColor={props.highlightColor}
        onClick={props.onItemClick}
      />
    ))}
  </Container>
)
